import React, {Component} from 'react';

export default class HeaderMobile extends Component{
    toggleAside = () => {
        const body = document.body;
        body.classList.toggle('kt-aside--on');
        
        // Buat/hapus overlay secara manual jika jQuery mati setelah React navigasi
        let overlay = document.querySelector('.kt-aside-overlay');
        if (body.classList.contains('kt-aside--on')) {
            if (!overlay) {
                overlay = document.createElement('div');
                overlay.className = 'kt-aside-overlay';
                overlay.style.zIndex = '99';
                overlay.onclick = this.toggleAside; // klik overlay tutup menu
                document.body.appendChild(overlay);
            }
        } else {
            if (overlay) {
                overlay.remove();
            }
        }
    };

    toggleHeader = () => {
        document.body.classList.toggle('kt-header-menu-wrapper--on');
    };

    render() {
        return (
            <div id="kt_header_mobile" className="kt-header-mobile  kt-header-mobile--fixed ">
                <div className="kt-header-mobile__logo">
                    <a href="demo1/index.html">
                        <img alt="Logo" src="./assets/media/logos/logo-light.png" style={{ maxHeight: '40px', width: 'auto' }} />
                    </a>
                </div>
                <div className="kt-header-mobile__toolbar">
                    <button className="kt-header-mobile__toggler kt-header-mobile__toggler--left"
                            id="kt_aside_mobile_toggler_react"
                            onClick={this.toggleAside}><span></span></button>
                    <button className="kt-header-mobile__toggler" id="kt_header_mobile_toggler_react" onClick={this.toggleHeader}><span></span></button>
                    <button className="kt-header-mobile__topbar-toggler" id="kt_header_mobile_topbar_toggler_react" onClick={() => document.body.classList.toggle('kt-header__topbar--mobile-on')}><i
                        className="flaticon-more"></i></button>
                </div>
            </div>
        )
    }
}